import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import { TContextTipsPaginated } from "../types";

export const QUERY_KEY_CONTEXT_TIPS = "admin-context-tips";

const getData = async (props: {
  token: string;
  page: number;
  search?: string;
}): Promise<TContextTipsPaginated> => {
  const params: Record<string, string> = {
    page: String(props.page),
    per_page: "15",
  };
  if (props.search) params.search = props.search;

  const url = `${END_POINT.BASE_URL}/v1/administrator/context-tips`;
  const res = await axios.get(url, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
    params,
  });

  const body = res.data;
  return {
    data: body.data ?? [],
    current_page: body.meta?.current_page ?? body.current_page ?? props.page,
    last_page: body.meta?.last_page ?? body.last_page ?? 1,
    per_page: body.meta?.per_page ?? body.per_page ?? 15,
    total: body.meta?.total ?? body.total ?? 0,
  };
};

export const useGetContextTips = (page: number, search?: string) => {
  const { token } = useGetUserInfo();
  return useQuery(
    [QUERY_KEY_CONTEXT_TIPS, page, search ?? ""],
    () => getData({ token, page, search }),
    { keepPreviousData: true },
  );
};
